module.exports = __webpack_public_path__ + "static/img/3.501de7d1.png";